module.exports = __webpack_public_path__ + "a9465a7da0512306e0fc8b76b9abfcea.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-kim.png
// module id = 659
// module chunks = 0